import React from 'react'
import Table from 'react-bootstrap/Table';
import business from "../assets/business.png"
import view from "../assets/view.png"
import del from "../assets/del.png"
import star from "../assets/star.png"
import edit from "../assets/edit.png"
import search from "../assets/search.png"

function BusinessTable() {
    return (<>

        <Table responsive className='table mt-2' style={{ background: "#fff" }}>
            <tbody style={{ backgroundColor: "#fff", position: 'relative' }}>
                <tr className='head_table ps-3' >

                    <td>
                        <p className='table_data'>Business id</p></td>
                    <td>
                        <p className='table_data2'>Preview</p>
                    </td>
                    <td>
                        <p className='table_data6'>Date Added</p>

                    </td>
                    <td>
                        <p className='table_data5'>Business Name</p>
                    </td>
                    <td>
                        <p className='table_data4'>Package Added/Expire</p>
                    </td>
                    <td>
                        <p className='table_data5'>Street# / Name</p>
                    </td>
                    <td>
                        <p className='table_data3'>State</p>
                    </td>
                    <td><p className='table_data3'>City</p></td>
                    <td>
                        <p className='table_data3'>Zip</p>
                    </td>
                    <td>
                        <p className='table_data7'>Phone Number</p>
                    </td>
                    <td>
                        <p className='table_data'>Actions</p>
                    </td>

                </tr>
                <tr style={{ height: "10px" }}></tr>
                <tr style={{ height: "10px" }}></tr>

                <tr style={{ border: "1px solid transparent" }}>
                    <td>
                        <p className='table_text'>#00019298812</p></td>
                    <td>
                        <img className='business-img' src={business} />
                    </td>
                    <td>
                        <div>
                            <p className='table_text'>02/09/2022</p>
                            <p className='table_text2'>by Adam Person</p>
                        </div>
                    </td>
                    <td>
                        <p className='table_text'>Cube Adx</p>
                    </td>
                    <td>
                        <p className='table_text'>Added - 02/09/2022</p>
                        <p className='table_text3'>Expire - 02/09/2023</p>
                    </td>
                    <td>
                        <p className='table_text'>106 Douers</p>
                    </td>
                    <td><p className='table_text'>Florida</p></td>
                    <td>
                        <p className='table_text'>Miami</p>
                    </td>
                    <td>
                        <p className='table_text'>32226</p>
                    </td>
                    <td>
                        <p className='table_text'>+1490300330</p>
                    </td>
                    <td>
                        <div className='d-flex gap-1 mt-3'>
                            <img src={view} />
                            <img src={star} />
                            <img src={edit} />
                            <img src={del} />
                        </div>
                    </td>
                </tr>
                <tr style={{ border: "1px solid transparent" }}>

                    <td>
                        <p className='table_text'>#00019298812</p></td>
                    <td>
                    <img className='business-img' src={business} />
                    </td>
                    <td>
                        <div>
                            <p className='table_text'>02/09/2022</p>
                            <p className='table_text2'>by Adam Person</p>
                        </div>

                    </td>
                    <td>
                        <p className='table_text'>Cube Adx</p>
                    </td>
                    <td>
                        <p className='table_text'>Added - 02/09/2022</p>
                        <p className='table_text3'>Expire - 02/09/2023</p>
                    </td>
                    <td>
                        <p className='table_text'>106 Douers</p>
                    </td>
                    <td><p className='table_text'>Florida</p></td>
                    <td>
                        <p className='table_text'>Miami</p>
                    </td>
                    <td>
                        <p className='table_text'>32226</p>
                    </td>
                    <td>
                        <p className='table_text'>+1490300330</p>
                    </td>
                    <td>
                        <div className='d-flex gap-1 mt-3'>
                            <img src={view} />
                            <img src={star} />
                            <img src={edit} />
                            <img src={del} />
                        </div>
                    </td>
                </tr>
                <tr style={{ border: "1px solid transparent" }}>

                    <td>
                        <p className='table_text'>#00019298812</p></td>
                    <td>
                        <img className='business-img' src={business} />
                    </td>
                    <td>
                        <div>
                            <p className='table_text'>02/09/2022</p>
                            <p className='table_text2'>by Adam Person</p>
                        </div>

                    </td>
                    <td>
                        <p className='table_text'>Cube Adx</p>
                    </td>
                    <td>
                        <p className='table_text'>Added - 02/09/2022</p>
                        <p className='table_text3'>Expire - 02/09/2023</p>
                    </td>
                    <td>
                        <p className='table_text'>106 Douers</p>
                    </td>
                    <td><p className='table_text'>Florida</p></td>
                    <td>
                        <p className='table_text'>Miami</p>
                    </td>
                    <td>
                        <p className='table_text'>32226</p>
                    </td>
                    <td>
                        <p className='table_text'>+1490300330</p>
                    </td>
                    <td>
                        <div className='d-flex gap-1 mt-3'>
                            <img src={view} />
                            <img src={star} />
                            <img src={edit} />
                            <img src={del} />
                        </div>
                    </td>
                </tr>
                <tr style={{ border: "1px solid transparent" }}>

                    <td>
                        <p className='table_text'>#00019298812</p></td>
                    <td>
                        <img className='business-img' src={business} />
                    </td>
                    <td>
                        <div>
                            <p className='table_text'>02/09/2022</p>
                            <p className='table_text2'>by Adam Person</p>
                        </div>

                    </td>
                    <td>
                        <p className='table_text'>Cube Adx</p>
                    </td>
                    <td>
                        <p className='table_text'>Added - 02/09/2022</p>
                        <p className='table_text3'>Expire - 02/09/2023</p>
                    </td>
                    <td>
                        <p className='table_text'>106 Douers</p>
                    </td>
                    <td><p className='table_text'>Florida</p></td>
                    <td>
                        <p className='table_text'>Miami</p>
                    </td>
                    <td>
                        <p className='table_text'>32226</p>
                    </td>
                    <td>
                        <p className='table_text'>+1490300330</p>
                    </td>
                    <td>
                        <div className='d-flex gap-1 mt-3'>
                            <img src={view} />
                            <img src={star} />
                            <img src={edit} />
                            <img src={del} />
                        </div>
                    </td>
                </tr>
                <tr style={{ border: "1px solid transparent" }}>

                    <td>
                        <p className='table_text'>#00019298812</p></td>
                    <td>
                        <img className='business-img' src={business} />
                    </td>
                    <td>
                        <div>
                            <p className='table_text'>02/09/2022</p>
                            <p className='table_text2'>by Adam Person</p>
                        </div>

                    </td>
                    <td>
                        <p className='table_text'>Cube Adx</p>
                    </td>
                    <td>
                        <p className='table_text'>Added - 02/09/2022</p>
                        <p className='table_text3'>Expire - 02/09/2023</p>
                    </td>
                    <td>
                        <p className='table_text'>106 Douers</p>
                    </td>
                    <td><p className='table_text'>Florida</p></td>
                    <td>
                        <p className='table_text'>Miami</p>
                    </td>
                    <td>
                        <p className='table_text'>32226</p>
                    </td>
                    <td>
                        <p className='table_text'>+1490300330</p>
                    </td>
                    <td>
                        <div className='d-flex gap-1 mt-3'>
                            <img src={view} />
                            <img src={star} />
                            <img src={edit} />
                            <img src={del} />
                        </div>
                    </td>
                </tr>


            </tbody>
        </Table>











    </>

    )
}

export default BusinessTable